var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip",class:{'is-disabled': _vm.disabled}},[_vm._t("default"),_vm._v(" "),(_vm.closable)?_c('button',{staticClass:"delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }